export default {
  created() {
    console.log("component created");
  }
};
